export default Object.freeze({ 
    sign_up_url: "https://fyers.in/signup.php",
    google_analytics_tracking_id: "UA-70168752-1",
    google_analytics_event_category: 'My_API',
    google_analytics_event_type: 'CTA'
});
